export default {
    computed: {
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        loading() {
            return this.$store.state.emailSchedules.loading
        },

        formFields() {
            return [
                {
                    field: 'is_active',
                    label: 'active',
                    type: 'checkbox',
                    required: false,
                    cols: 2,
                }, {
                    field: 'name',
                    label: 'name',
                    type: 'text',
                    required: true,
                    cols: 5,
                },
                {
                    field: 'report_type',
                    label: this.$translate('report_type'),
                    type: 'select',
                    required: false,
                    cols: 5,
                },
                {
                    field: 'description',
                    label: 'description',
                    type: 'textarea',
                    required: false,
                    cols: 12,
                },
                {
                    field: 'email_subject',
                    label: 'subject',
                    type: 'text',
                    required: true,
                    cols: 12,
                },
                {
                    field: 'email_from_name',
                    label: this.$translate('from_name'),
                    type: 'text',
                    required: true,
                    cols: 12,
                },
                {
                    field: 'query_fields',
                    label: 'Query',
                    type: 'query',
                    required: true,
                    cols: 12,
                },

                {
                    field: 'frequency',
                    label: 'frequency',
                    type: 'select',
                    required: true,
                    cols: 4,
                },
                {
                    field: 'next_date',
                    label: 'next_date',
                    type: 'date',
                    required: true,
                    min: this.getMinStartDate(),
                    cols: 4,
                },
                {
                    field: 'day_of_week',
                    label: 'day_of_week',
                    type: 'select',
                    required: false,
                    cols: 4,
                },
                {
                    field: 'time_of_day',
                    label: 'time_of_day',
                    type: 'time',
                    required: false,
                    cols: 4,
                },
                {
                    field: 'termination_date',
                    label: 'termination_date',
                    type: 'date',
                    required: false,
                    cols: 4,
                },
                {
                    field: 'last_date',
                    label: 'Last Used',
                    type: 'date',
                    readonly: true,
                    cols: 4,
                },
            ];

        },
        report_types() {
            return [
                { value: 'cS58GVS', text: 'Statement Type 1' },
                { value: '0h4Gswo', text: 'Statement Type 2' },
                { value: '9eVjSVg', text: 'INVOICE' },
            ];
        },
        frequencies() {
            return [
                { value: 0, text: 'One-Off' },
                { value: 1, text: 'Daily' },
                { value: 7, text: 'Weekly' },
                { value: 30, text: 'Monthly' },
                { value: 90, text: 'Quarterly' },
            ]
        },

        weekDays() {
            return [
                { value: 0, text: 'Sunday' },
                { value: 1, text: 'Monday' },
                { value: 2, text: 'Tuesday' },
                { value: 3, text: 'Wednesday' },
                { value: 4, text: 'Thursday' },
                { value: 5, text: 'Friday' },
                { value: 6, text: 'Saturday' },
            ]
        },

        timeOfDayDisplay: {
            set(value) {
                console.log('time of day display:', value)
                const parts = (value ?? '').split(':')
                this.$set(
                    this.model,
                    'time_of_day',
                    Number(parts[0]) * 60 + Number(parts[1])
                )
            },
            get() {
                let x = this.model.time_of_day || 0
                const hr = Math.floor(x / 60)
                const min = x - hr * 60
                const y = `${String(hr).padStart(2, '0')}:${String(
                    min
                ).padStart(2, '0')}`
                console.log('y time of day:', y)
                return y
            },
        },
    },


    methods: {
        cancel() {
            this.$emit('cancel')
        },
        is_one_off_linked(key) {
            const checkKeys = ['last_date', 'day_of_week']
            const isIncluded = key => {
                const _is_included = checkKeys.includes(key)
                console.log({ key, _is_included })
                return _is_included
            }
            return this.model.frequency == 0 && isIncluded(key)
        },
        getLabel(value) {
            return this.$translate(value)
        },

        getOptions(field) {
            console.log('field', field)
            switch (field) {
                case 'frequency':
                    return this.frequencies
                case 'day_of_week':
                    return this.weekDays
                case 'category':
                    return (
                        this.$store.state.emailSchedules?.options?.categories ??
                        []
                    )
                case "report_type": return this.report_types
                default:
                    return []
            }
        },
    },
}
